<div class="container">
    <br>
    <div class="row">
        <div class="col-sm-7 col-12 title-trends">Tendencias sectoriales</div>
        <div class="col-sm-5 col-12">
            <div class="row justify-content-end">
                <a class="col-3" routerLink="../tendencia-global">
                    <img class="icon-trends" src="assets/img/t/tg-w.webp" alt="Tendencia global"></a>
                <a class="col-3" routerLink="../tendencia-nacional">
                    <img class="icon-trends" src="assets/img/t/tn-w.webp" alt="Tendencia nacional"></a>
                <a class="col-3" routerLink="../tendencia-territorial">
                    <img class="icon-trends" src="assets/img/t/tt-w.webp" alt="Tendencia territorial"></a>
                <a class="col-3" routerLink="../tendencia-sectorial">
                    <img class="icon-trends" src="assets/img/t/ts-b.webp" alt="Tendencia sectorial"></a>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <p class="col-12"><b>Fenómeno</b> consistente en el tiempo que se manifiesta <b>en un sector determinado</b>. Su
            configuración
            <b>incide en el desarrollo sectorial y territorial</b> actual y en el mediano o largo plazo.
        </p>
    </div>

    <app-carousel [idTier1ForSlider]="idTier1"></app-carousel>

    <div class="row">
        <div class="col-md-12">
            <p class="py-4">Seleccione un sector para explorar las principales tendencias:</p>
        </div>
    </div>
    <div class="gradient-trend">
        <div class="row">
            <div class="col-6 col-sm-4 col-md-3 pb-3" *ngFor="let s of filteredSector">
                <div class="sector-t3" [routerLink]="['/tendencia-sectorial', s.id]"
                    [ngClass]="{'sector-t3-active': s.id == selectedSectorId}">
                    <span class="span-shortname">{{s.shortname}}</span>
                    <ng-container *ngIf="s.icon">
                        <span class="span-shortname">
                            <img class="img-fluid icon-sector" src="assets/img/sectores/{{s.icon}}" alt="">
                        </span>
                    </ng-container>
                    <ng-container *ngIf="!s.icon">
                        <span class="span-shortname">
                            <img class="img-fluid icon-sector" src="assets/img/sectores/sector.svg" alt="">
                        </span>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div>
        <router-outlet></router-outlet>
    </div>
</div>